import { useMemo } from 'react'
import { guidelines } from './constants'
import { Guideline } from './types'

const usePasswordGuidelines = (
  password: string,
  confirmation: string,
  isDirty = false,
) => {
  const rules = useMemo((): Guideline[] => {
    if (!isDirty) {
      return guidelines.map(({ id, label }) => ({
        id,
        label,
        state: 'neutral',
      }))
    }

    return guidelines.map(({ id, label, test }) => ({
      id,
      label,
      state: test(password, confirmation) ? 'valid' : 'invalid',
    }))
  }, [password, confirmation, isDirty])

  const allValid = useMemo(
    () => isDirty && rules.every((rule) => rule.state === 'valid'),
    [rules, isDirty],
  )

  return { rules, allValid }
}

export default usePasswordGuidelines
